import { IconCircleCheck } from '@tabler/icons-react';
import clsx from 'clsx';

const BStepper = ({ currentStep, steps }) => {
  return (
    <ul className="relative flex flex-row gap-x-2 overflow-auto">
      {steps.map((step, index) => {
        return (
          <li key={index} className="group flex flex-1 shrink basis-0 items-center gap-x-2">
            <div
              className={clsx(
                'inline-flex min-h-7 min-w-7 items-center justify-center align-middle text-xs',
                index <= currentStep ? 'text-primary-600' : '',
                index === currentStep && 'italic'
              )}
            >
              {index < currentStep && <IconCircleCheck className={clsx('h-4 w-4')} />}{' '}
              <span className="ms-2 block text-sm font-medium">{step}</span>
            </div>
            <div
              className={clsx(
                'h-px w-full flex-1 group-last:hidden',
                index < currentStep ? 'bg-primary-600' : 'bg-slate-200'
              )}
            ></div>
          </li>
        );
      })}
    </ul>
  );
};

export default BStepper;
